import * as jQuery from 'jquery'

export const $ = jQuery;
